import { getNodeHistoryDetailByVersion } from '@/endpoints'
import { HistoryDetailDto, StructureDetailDto } from '@/endpoints/models'
import { requireSelectedBranchId } from '@/pages/User/pages/Home/components/TreePanel/branchSelectionStorage'
import { mddApi } from '@/rtkApi'
import { apiCallAction, AppDispatch } from '@/store/utils'

import { NODE_LOAD, NODE_LOAD_HISTORY_VERSION } from './constants'

export interface LoadNode {
	payload: StructureDetailDto
	type: typeof NODE_LOAD
}

export interface LoadNodeHistoryVersion {
	payload: HistoryDetailDto
	type: typeof NODE_LOAD_HISTORY_VERSION
}

/**
 * V1 `GET /branch/{branchId}/structure/{id}` — full StructureDetailDto
 * including `data` / `workingData`. V2 metadata is a different API.
 */
export const loadNode =
	(id: number) =>
	async (dispatch: AppDispatch) => {
		const branchId = requireSelectedBranchId()
		const request = dispatch(
			mddApi.endpoints.getNodeDetailUsingGet.initiate(
				{ branchId, structureId: id },
				{ forceRefetch: true },
			),
		)

		try {
			const payload = await request.unwrap()

			dispatch({
				type: NODE_LOAD,
				payload,
			})

			return payload
		} finally {
			request.unsubscribe()
		}
	}

export const loadNodeHistoryVersion = (
	id: number,
	version: number,
	envId?: number,
) =>
	apiCallAction<LoadNodeHistoryVersion>(
		() => getNodeHistoryDetailByVersion(id, version, { envId }),
		NODE_LOAD_HISTORY_VERSION,
	)
